import React from 'react';
    import Header from '../components/Header';
    import HeroSection from '../components/HeroSection';
    import AboutSection from '../components/AboutSection';
    import CoachingServicesSection from '../components/CoachingServicesSection';
    import TestimonialsSection from '../components/TestimonialsSection';
    import SubscribeSection from '../components/SubscribeSection';
    import InstagramSection from '../components/InstagramSection';
    import Footer from '../components/Footer';

    const HomePage = () => {
      return (
        <div className="min-h-screen">
          <Header />
          <HeroSection />
          <AboutSection />
          <CoachingServicesSection />
          <TestimonialsSection />
          <SubscribeSection />
          <InstagramSection />
          <Footer />
        </div>
      );
    };

    export default HomePage;